import { render, staticRenderFns } from "./UserTeamSelector.vue?vue&type=template&id=9ae25f02"
import script from "./UserTeamSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTeamSelector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports